import { render, staticRenderFns } from "./EditNewExam.html?vue&type=template&id=160bb7a8&external"
import script from "./EditNewExam.ts?vue&type=script&lang=ts&external"
export * from "./EditNewExam.ts?vue&type=script&lang=ts&external"
import style0 from "./EditNewExam.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports